import classnames from 'classnames';
import React from 'react';
import { IconRenderer } from "../../../helper/components/IconRenderer.js";
import { DropdownWrapper } from "../../dropdownWrapper/DropdownWrapper.js";
import { IconButton } from "../../iconButton/IconButton.js";
import styles from "./DropdownToolbarItem.module.js";
import genericStyles from "./GenericToolbarItem.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function DropdownToolbarItem({
  icon,
  activeItem,
  options,
  content = 'ICON',
  on,
  disabled,
  useChildAsButton,
  title
}) {
  return /*#__PURE__*/_jsx(DropdownWrapper, {
    options: options,
    activeItem: activeItem,
    className: styles.dropdownToolbarItem,
    useChildAsButton: useChildAsButton,
    disabled: disabled,
    children: ({
      ref,
      handleClick
    }) => {
      if (content === 'ICON') {
        return /*#__PURE__*/_jsx(IconButton, {
          className: classnames(genericStyles.item, {
            [genericStyles.active]: on
          }),
          ref: ref,
          disabled: disabled,
          title: title,
          toolbar: true,
          tertiary: true,
          onClick: handleClick,
          icon: icon
        });
      }
      return /*#__PURE__*/_jsx("span", {
        className: disabled && styles.disabled,
        ref: ref,
        onClick: handleClick,
        children: /*#__PURE__*/_jsx(IconRenderer, {
          icon: icon
        })
      });
    }
  });
}